import { BankAccountExportSelection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/bankAccountsExport.types';
import {
	getExportSelection,
	getExportSelectionCount,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/components/BankAccounts.utils';
import { BulkActionGroup } from '@dealstack/frontend/shared/components/Table/MantineTable/ActionsButton/ActionsButton.types';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { DataMipInvestorBankAccountRes } from '@dealstack/shared/lib/generated';
import { Table } from '@tanstack/react-table';

// No executeImmediately: picking Download enters selection mode, so the export always
// runs against chosen rows.
//
// The action is captured in state when the menu item is picked — before a single row is
// ticked — so the label and the export read through the table instance rather than
// closing over a count or a resolved selection, either of which would freeze at zero.
export const createBulkActions = ({
	table,
	isDownloading,
	tMipManage,
	onDownload,
}: {
	table: Table<DataMipInvestorBankAccountRes>;
	isDownloading: boolean;
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>;
	onDownload: (selection: BankAccountExportSelection) => void;
}): BulkActionGroup<DataMipInvestorBankAccountRes> => ({
	secondary: [
		{
			key: 'download_bank_accounts',
			label: tMipManage('bank_accounts.bulk_actions.download'),
			buttonLabel: () => {
				// getRowCount() is the server's filtered total, so a select-all counts every
				// matching row rather than the page in front of the reviewer.
				const count = getExportSelectionCount(
					getExportSelection(table),
					table.getRowCount()
				);

				return `${tMipManage('bank_accounts.bulk_actions.download')} (${count})`;
			},
			disabled: isDownloading,
			showBulkActionItemCount: true,
			onExecute: (currentTable) => onDownload(getExportSelection(currentTable)),
		},
	],
});
